import { effect, Signal, signal } from '@angular/core';
import { MaybeAsync } from '@angular/router';
import { isObservable, Observable } from 'rxjs';

/**
 * @deprecated Use 'resource' or 'rxResource' from '@angular/core' instead.
 */
export const computedAsync = <T>(computation: () => MaybeAsync<T> | undefined | null, initialValue: T = null): Signal<T> => {
    const resultSignal = signal<T>(initialValue);

    effect(async () => {
        const result = computation();
        const unwrappedResult = await (isObservable(result) ? (result as Observable<T>).toPromise() : result);
        resultSignal.set(unwrappedResult);
    });

    return resultSignal.asReadonly();
};
